export default "__VITE_ASSET__Nf6qa4G8__"